module.exports = __webpack_public_path__ + "static/media/ic-slidearrow-right.44a26b42.svg";